import { gql } from '@apollo/client';

export const GET_AUDIT_LOGS_ADMIN = gql`
  query GetAuditLogsAdmin($input: GetAuditLogsAdminInput!) {
    getAuditLogsAdmin(input: $input) {
      items {
        id
        type
        performedById
        performedByEmail
        performedByName
        performedByRole
        performedBy {
          id
          email
          firstName
          lastName
          role
        }
        targetType
        targetId
        data
        createdAt
        ... on AuditLogInterview {
          interviewAction: action
        }
        ... on AuditLogVideoEditRequest {
          videoEditRequestAction: action
        }
        ... on AuditLogDesignRequest {
          action
        }
        ... on AuditLogCampaignBalance {
          action
        }
        ... on AuditLogPromoCode {
          action
        }
        ... on AuditLogCounterOffer {
          action
        }
        ... on AuditLogDeliverableReview {
          action
        }
        ... on AuditLogCbTeam {
          action
        }
        ... on AuditLogTicketOrder {
          action
        }
      }
      startAfter
    }
  }
`;
